import { ref } from 'vue'
import { useEmitter } from '../emitter/index.js'
import { useReadyTrigger } from '@booksy-com/vue-tools'

const readyTrigger = useReadyTrigger()

const isOpen = ref(false)

const onCreatedHandler = (handlers) => {
  const { on, EVENTS } = useEmitter()

  on(EVENTS.MODAL_OPEN, handlers.onOpen)
  on(EVENTS.MODAL_CLOSE, handlers.onClose)
  on(EVENTS.MODAL_CANCEL, handlers.onCancel)
  readyTrigger.resolveTrigger()
}

const onBeforeDestroyHandler = (handlers) => {
  const { off, EVENTS } = useEmitter()

  off(EVENTS.MODAL_OPEN, handlers.onOpen)
  off(EVENTS.MODAL_CLOSE, handlers.onClose)
  off(EVENTS.MODAL_CANCEL, handlers.onCancel)
}

const _modalAction = (action) => {
  return readyTrigger.promise.then(() => {
    return action()
  })
}

const open = async (options) => {
  return _modalAction(() => {
    const { emit, EVENTS } = useEmitter()

    isOpen.value = true

    emit(EVENTS.MODAL_OPEN, options)
  })
}

const close = async () => {
  return _modalAction(() => {
    const { emit, EVENTS } = useEmitter()

    isOpen.value = false

    emit(EVENTS.MODAL_CLOSE)
  })
}

const cancel = async () => {
  return _modalAction(() => {
    const { emit, EVENTS } = useEmitter()

    isOpen.value = false

    emit(EVENTS.MODAL_CANCEL)
  })
}

export function useModal () {
  return { open, close, cancel, isOpen, onCreatedHandler, onBeforeDestroyHandler }
}
